import { GetStartedForm } from '@pages/get-started-form';
import { CreatingOkrs } from '@pages/creating-okrs';
import { CompanyOverview } from '@pages/company-overview';

import ErrorPage from './error-page-404';
import RouteGuard from './route-guard';
import { CognitoKey } from '@pages/cognito-key';
import DiagnosticPage from '@pages/diags';

const protectedRoutes = [
  {
    path: '/get-started',
    element: (
      <RouteGuard>
        <GetStartedForm />
      </RouteGuard>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/company-overview',
    element: (
      <RouteGuard>
        <CompanyOverview />
      </RouteGuard>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/okrs',
    element: (
      <RouteGuard>
        <CreatingOkrs />
      </RouteGuard>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/cognito',
    element: (
      <RouteGuard>
        <CognitoKey />
      </RouteGuard>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/diags',
    element: (
      <RouteGuard>
        <DiagnosticPage />
      </RouteGuard>
    ),
    errorElement: <ErrorPage />,
  },
];

export default protectedRoutes;
